// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__1UdDk","logo":"Footer_logo__ZoUn-","rights":"Footer_rights__+w5A5"};